export default __webpack_public_path__ + "static/media/ProSF.92d89c0c.jpg";